import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebase-config";
import { useNavigate } from "react-router-dom";
// Import Bootstrap CSS at the application level instead
import { Container, Row, Col, Card, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';
import '../styles/LoginPage.css';

const ADMIN_UID = "Nicsf1WhEaNeipzklpKJ42zNGB23";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;
      localStorage.setItem("uid", uid);
      localStorage.setItem("isAdmin", uid === ADMIN_UID ? "true" : "false");
      navigate("/");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={5} xl={4} className="login-card-container">
            <div className="text-center mb-4">
              <img 
                src="https://firebasestorage.googleapis.com/v0/b/johnson-codes.firebasestorage.app/o/system_images%2Flogo.png?alt=media&token=a06af1f0-9040-4cfa-b76b-2b889fc61db0" 
                alt="System Logo" 
                className="login-logo img-fluid mb-3" 
                style={{ maxHeight: "100px" }}
              />
            </div>
            
            <Card className="shadow-lg border-0 rounded-lg">
              <Card.Header className="bg-primary text-white text-center py-3">
                <h3 className="font-weight-light mb-0 fs-5">
                  <FaSignInAlt className="me-2" />
                  KMS login                </h3>
              </Card.Header>
              
              <Card.Body className="p-3 p-md-4">
                {error && (
                  <Alert variant="danger" className="mb-3">
                    {error}
                  </Alert>
                )}
                
                <Form onSubmit={handleLogin}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light">
                        <FaEnvelope />
                      </InputGroup.Text>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="py-1"
                      />
                    </InputGroup>
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <div className="d-flex justify-content-between">
                      <Form.Label>Password</Form.Label>
                    </div>
                    <InputGroup>
                      <InputGroup.Text className="bg-light">
                        <FaLock />
                      </InputGroup.Text>
                      <Form.Control
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="py-1"
                      />
                    </InputGroup>
                  </Form.Group>
                  
                  <div className="d-grid mt-4">
                    <Button
                      variant="primary"
                      type="submit"
                      className="py-2 text-uppercase fw-bold"
                      disabled={isLoading}
                    >
                      {isLoading ? 'Signing in...' : 'Sign In'}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
              
              <Card.Footer className="py-2 bg-light text-center">
                <div className="small">
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LoginPage;
